module.exports = __webpack_public_path__ + "static/QUUBMedium-a0713f43bedbc3660c9e19a8d55e9237.ttf";